import React from "react";
import "./tenantrentpaymentstatus.css";
import { FaCheckCircle } from "react-icons/fa";

const TenantPaymentStatus: React.FC<{ paymentHistory: any[] }> = ({
  paymentHistory,
}) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth(); // 0-indexed (0 = January)
  const currentYear = currentDate.getFullYear();

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Generate status for each month
  const monthStatuses = months.map((month, index) => {
    const hasPaid = paymentHistory.some((payment) => {
      const paymentDate = new Date(payment.paymentDate);
      return (
        paymentDate.getMonth() === index && // Matches the current month
        paymentDate.getFullYear() === currentYear
      );
    });

    const isPast = index < currentMonth;
    // const isUpcoming = index > currentMonth;

    let color = "gray"; // Default: Gray for upcoming months
    if (hasPaid) {
      color = "green"; // Green if paid
    } else if (isPast) {
      color = "red"; // Red if unpaid and month has passed
    }

    return { month, color };
  });

  return (
    <div className="months-container">
      {monthStatuses.map(({ month, color }, idx) => (
        <div key={idx} className="month">
          <FaCheckCircle style={{ color }} />
          <span>{month}</span>
        </div>
      ))}
    </div>
  );
};

export default TenantPaymentStatus;
